function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {return Object.getOwnPropertyDescriptor(source, sym).enumerable;}));}ownKeys.forEach(function (key) {_defineProperty(target, key, source[key]);});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;} /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              * SurveyCalculateController
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              * @namespace gplans.survey.controllers
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              */
(function () {
  'use strict';SurveyCalculateController.$inject = ["$rootScope", "$timeout", "$state", "$window", "$http", "$q", "Authentication", "User", "Profile", "$localStorage", "mesSystem", "MeasurementSystem", "Funnel", "UserService"];

  angular.
  module('gplans.survey.controllers').
  controller('SurveyCalculateController', SurveyCalculateController);

  SurveyCalculateController.$inject = ['$rootScope', '$timeout', '$state', '$window', '$http', '$q', 'Authentication', 'User',
  'Profile', '$localStorage', 'mesSystem', 'MeasurementSystem', 'Funnel', 'UserService'];

  /**
                                                                                          * @namespace SurveyCalculateController
                                                                                          */
  function SurveyCalculateController($rootScope, $timeout, $state, $window, $http, $q, Authentication, User, Profile, $localStorage,
  mesSystem, MeasurementSystem, Funnel, UserService) {
    $rootScope.pageTitle = 'Survey Calculate';
    var vm = this;
    vm.user = User;
    vm.calcFinished = vm.user && !$rootScope.quizChanged;
    vm.resetAccount = function () {
      Authentication.resetAccount();
    };

    $localStorage['bloodTest'] = false;

    vm.progress = 0;
    var timeout = 0;
    vm.items = [{
      "text": "Searching Metabolic Type Database",
      "timeout": 1000 },
    {
      "text": "Compiling Personalized Plan",
      "timeout": 1000 },
    {
      "text": "Factoring Resting and Active BMR",
      "timeout": 1000 },
    {
      "text": "Calculating Ideal Calorie Intake",
      "timeout": 1000 },
    {
      "text": "Searching 100,000 Item Database",
      "timeout": 1000 },
    {
      "text": "Cholesterol, Glucose & Trig Ratios",
      "timeout": 1000 },
    {
      "text": "Generating Personalized Plan",
      "timeout": 1000 }];



    vm.userSurvey = $localStorage.userSurvey; // todo: move to Survey Service

    if (vm.calcFinished) {
      // ResetModal.init();
      vm.items.forEach(function (i) {
        i.complete = true;
      });
      vm.progress = 100;
      return;
    }

    vm.setTimeout = function (i) {
      timeout += vm.items[i].timeout;
      $timeout(function () {
        vm.items[i].complete = true;
        vm.progress = (i + 1) / vm.items.length * 100;
        if (vm.progress == 100) {
          $timeout(function () {
            delete $rootScope.quizChanged;
            Funnel.nextStep(register);
          }, 1000);
        }
      }, timeout);
    };

    if ($rootScope.offerId) {
      for (var i = 0; i < vm.items.length; i++) {
        vm.setTimeout(i);
      }
    } else
    {
      $q.resolve().
      then(function () {return $q(function (rs, rj) {return $timeout(rs, 100);});}).
      then(function () {return angular.element('.js-generate-result-component').addClass('is-start-loading');}).
      then(function () {return $q(function (rs, rj) {return $timeout(rs, 1100);});}).
      then(function () {return angular.element('.js-generate-result-component').addClass('is-complete-loading');}).
      then(function () {return $q(function (rs, rj) {return $timeout(rs, 4100);});}).
      then(function () {return Funnel.nextStep(register);});
    }

    function register() {
      var user;
      Authentication.getAuthenticatedAccount({
        'email': vm.email,
        'user_survey_pk': $localStorage['userSurvey'],
        'blood_test': $localStorage['bloodTest'] },
      'base.complete', {
        userSurvey: $localStorage['userSurvey'] }).

      then(function (res) {
        if (window.fbq) fbq('track', 'Lead');
        user = res;
        user.gender = $window.gplansStorage.gender;
        user.age = $window.gplansStorage.age;
        if (mesSystem == 'SI') {
          user.goal_weight = Math.round(MeasurementSystem.convertKgToLbs($window.gplansStorage.goal_weight));
          user.current_weight = Math.round(MeasurementSystem.convertKgToLbs($window.gplansStorage.current_weight));
          user.height = Math.round(MeasurementSystem.convertCmToInch($window.gplansStorage.height));
        } else
        {
          user.height = $window.gplansStorage.height;
          user.goal_weight = $window.gplansStorage.goal_weight;
          user.current_weight = $window.gplansStorage.current_weight;
        }

        // show results before update is completed
        if (UserService.data.id) {
          UserService.set(_objectSpread({},
          UserService.data, {
            first_name: user.first_name,
            last_name: user.last_name,
            gender: user.gender,
            age: user.age,
            current_weight: parseFloat(user.current_weight),
            goal_weight: parseFloat(user.goal_weight),
            height: parseFloat(user.height) }));

        }

        return 'processed';
      }, function (err) {
        console.log(err);
        return $q.reject(err);
      }).
      then(function () {
        if ($localStorage.bloodTypeResult && $localStorage.bloodTypeResult.id) {
          var oCheckin = {
            metabolic_type: $localStorage.bloodTypeResult.id,
            weight: UserService.data.current_weight,
            week_number: 1 };


          return Profile.createCheckin(oCheckin).then(function (res) {
            UserService.data.last_checkin = res.data;
          });
        } else {
          return fetchUserSurvey();
        }
      }).
      then(function () {
        return Profile.update(user).then(profileSuccessFn, profileErrorFn);

        function profileSuccessFn(res, status, headers, config) {
          Authentication.setAuthenticatedAccount(res.data);

          if (UserService.data.id) {
            UserService.set(_objectSpread({},
            UserService.data, {
              first_name: res.data.first_name,
              last_name: res.data.last_name,
              gender: res.data.gender,
              age: parseInt(res.data.age),
              current_weight: parseFloat(res.data.current_weight),
              goal_weight: parseFloat(res.data.goal_weight),
              height: parseFloat(res.data.height) }));

          }

          var weightGoalDirection;
          if (UserService.data.goal_weight > UserService.data.current_weight + 6) {
            weightGoalDirection = 'gain';
          } else
          if (UserService.data.goal_weight < UserService.data.current_weight - 6) {
            weightGoalDirection = 'lose';
          } else
          {
            weightGoalDirection = 'maintain';
          }

          var oMisc = { 'key': 'weightGoalDirection', 'value': weightGoalDirection };

          Profile.createMisc(oMisc).then(function (res) {
            Profile.updateMisc({ key: 'straightSaleComplete', value: '1' }).then(function (res) {
              $state.go('gplans.userConsole');
            });
          }, function (err) {
            Profile.updateMisc({ key: 'straightSaleComplete', value: '1' }).then(function (res) {
              $state.go('gplans.userConsole');
            });
          });
        }

        function profileErrorFn(data, status, headers, config) {
          console.log(data);
          return $q.reject(data);
        }
      });
    }

    function fetchUserSurvey() {
      return $http.get(gplansConf.API_URL + '/api/v1/usersurveys/' + $localStorage.userSurvey + '/').then(function (data) {
        vm.usersurvey = data.data;
        vm.metabolic_type = vm.usersurvey.metabolic_type;
        var oCheckin = {
          metabolic_type: vm.usersurvey.metabolic_type,
          weight: UserService.data.current_weight,
          week_number: 1 };


        return Profile.createCheckin(oCheckin);
      }).then(function (res) {
        UserService.data.last_checkin = res.data;
      });
    }

  }
})();